class Facet {
    constructor() {
        let doc = document
        this.qsa = (s, o = doc) => o.querySelectorAll(s),
            this.qs = (s, o = doc) => o.querySelector(s)
        this.$body = document.querySelector('body')

        this.listeners()
        const $isFiltered = this.qsa('.active-filters a').length
        if($isFiltered > 1) {this.elementsActivated();}
    }











    //? - =========================  listeners  ========================= -//
    //? - =========================  listeners  ========================= -//
    listeners() {
        console.log('listeners')
        let that = this
        this.filters_applied = null
        let url = window.location.href


        // _______  each filters
        const $each_filter = this.qsa('li.filter-group-display__list-item input[type=checkbox]')
        $each_filter.forEach(el => {
            if (el.disabled) el.closest('li').style.opacity = .2
            el.addEventListener('change', function () {
                let params = `${el.name}=${el.value}`
                if (this.checked) {
                    if(url.includes('?filter') || url.includes('?sort_by=')) {
                        that.filters_applied = true
                        that.fetchNewPage(`${url}&${params}`)
                    } else {
                        that.filters_applied = false
                        that.fetchNewPage(`${url}?${params}`)
                    }
                } else {

                    console.log(document.querySelector(`[data-id="${params}"]`))
                    let replaced_url = document.querySelector(`[data-id="${params}"]`).getAttribute('href')
                    console.log(replaced_url)
                    that.fetchNewPage(`${replaced_url}`)
                }
            });
        })



        // _______  range
        const $inputs_range_from = document.querySelector('.filter-group-display__price-range-from input')
        const $inputs_range_to = document.querySelector('.filter-group-display__price-range-to input')
        var typingTimer;
        var doneTypingInterval = 1500;
        var $remove_pricerange = document.querySelectorAll('.remove-pricerange')
        console.log($remove_pricerange.length)

        $inputs_range_from.addEventListener('keyup', (el)=> {
            clearTimeout(typingTimer);
            let value = $inputs_range_from.value
            typingTimer = setTimeout(() => {
                let params = `${el.target.name}=${el.target.value}&${$inputs_range_to.name}=${$inputs_range_to.value}`
                doneTyping(params);
            }, doneTypingInterval);

        })
        $inputs_range_from.addEventListener('keydown', function () {
            clearTimeout(typingTimer);
        });

        $inputs_range_to.addEventListener('keyup', (el)=> {
            clearTimeout(typingTimer);
            let value = $inputs_range_to.value
            typingTimer = setTimeout(() => {
                let params = `${$inputs_range_from.name}=${$inputs_range_from.value}&${el.target.name}=${el.target.value}`
                doneTyping(params);
            }, doneTypingInterval);
        })
        $inputs_range_to.addEventListener('keydown', function () {
            clearTimeout(typingTimer);
        });

        function doneTyping(params) {
            if($remove_pricerange.length > 0) {
                url = `${$remove_pricerange[0].getAttribute('href')}`
                console.log(url)

            }
            if(url.includes('?filter') || url.includes('?sort_by=')) {
                that.filters_applied = true
                that.fetchNewPage(`${url}&${params}`)
            } else {
                that.filters_applied = false
                that.fetchNewPage(`${url}?${params}`)
            }
        }
    }











    //? - =========================    ========================= -//
    //? - =========================    ========================= -//

    fetchNewPage(url) {
        console.log(url)
        let that = this

        fetch(url).then(function (response) {
            return response.text();
        })
            .then(function (html) {
                console.log('fetchNewPage')
                window.history.replaceState({}, '', `${url}`);
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                const items_to_replace = ['.mini-grid', '.products-count']
                items_to_replace.forEach(el => that.replaceItems(el, doc))
                that.replaceRemoveItems(doc)
                that.replaceFilters(doc)
                that.replacePagination(doc)
            })
            .catch(function (err) {
                console.warn('Something went wrong.', err);
            });
    }

    replaceItems(item, DOM) {
        //replace infos
        const current_infos = document.querySelector(`${item}`);
        const new_infos = DOM.querySelector(`${item}`);
        if (new_infos && current_infos) current_infos.replaceWith(new_infos);
    }

    replacePagination(DOM) {
        console.log('replae page');
        const current_pagination = document.querySelector('.pagination');
        const new_pagination = DOM.querySelector('.pagination');
        if( new_pagination ) { 
            if( current_pagination ) {
                console.log(current_pagination)
                current_pagination.replaceWith(new_pagination);
            }
            else {
                document.querySelector('.main-collections__grid').append(new_pagination)
            }
            console.log('has')
        } else { 
            if( current_pagination ) {
                current_pagination.remove()
            }
        }


    }

    replaceFilters(DOM) {
        //replace infos
        let current_filters = document.querySelectorAll(`.filter-replace`);
        let new_filters = DOM.querySelectorAll(`.filter-replace`);
        current_filters.forEach((el, index) => {
            el.replaceWith(new_filters[index]);
        })
        // if (new_filters && current_filters) current_filters.replaceWith(new_filters);
        console.log('replaceFilters')
        this.listeners()
    }



    elementsActivated() {
        console.log('elementsActivated')
        // _______ active filters
        const $each_activated = this.qsa('.active-filters a')
        $each_activated.forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                let params = `${el.getAttribute('href')}`
                this.fetchNewPage(`${params}`)
            });
        })
    }
    replaceRemoveItems(DOM) {
        const $new_activated_filter = DOM.querySelectorAll('.active-filters');
        document.querySelectorAll('.active-filters').forEach((el, index) => {
            el.replaceWith($new_activated_filter[index]);
        })
        this.elementsActivated()
        
    }
}

if(window.innerWidth > 1024) {
    new Facet()
}